import React from "react";
import { Button } from "../../../../../shadcn/components/ui/button";

interface KYCRejectedNoticeProps {
  title?: string;
  reasonLabel?: string;
  reason?: string | null;
  onRetry?: () => void;
  loading?: boolean;
  primaryButtonLabel?: string;
  showRetryButton?: boolean;
}

export default function KYCRejectedNotice({
  title = "Application Rejected by Banker",
  reasonLabel = "Rejection Reason :",
  reason,
  onRetry,
  loading = false,
  primaryButtonLabel = "Initiate New Participation Request",
  showRetryButton = true,
}: KYCRejectedNoticeProps) {
  const displayReason =
    reason && reason.trim().length > 0 ? reason : "Rejected";

  return (
    <div className="mb-2 md:mb-4 flex items-center space-x-1 px-4 py-3 bg-brand-lightOrange rounded-sm border-l-4 border-x-brand-orange-dark">
      <div>
        <p className="text-brand-textBlack text-base font-semibold pb-2">
          {title}
        </p>
        <p className="text-yellow-800 text-xs font-medium">
          <span className="text-brand-textBlack font-semibold">
            {reasonLabel}
          </span>{" "}
          <span className="text-gray-500">{displayReason}</span>
        </p>
        {showRetryButton && (
          <div className="flex justify-center lg:justify-start mt-8">
            <Button
              disabled={loading || !onRetry}
              onClick={onRetry}
              className="w-full max-w-[350px] mid:w-[300px]"
            >
              {primaryButtonLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
